type LinkData = {
  filename: string;
  blob: Blob;
  type: string;
};

type CSVData = {
  filename: string;
  file: Blob;
};

export function createLink({
  filename,
  blob,
  type = 'application/pdf',
}: LinkData) {
  const blobPdf = new Blob([blob], { type });

  // @ts-ignore
  const { msSaveOrOpenBlob } = window.navigator;

  if (msSaveOrOpenBlob) {
    msSaveOrOpenBlob(blobPdf, filename);

    return undefined;
  }

  return window.URL.createObjectURL(blobPdf);
}

export function downloadPdfFile({ filename, file }: CSVData) {
  const url = createLink({
    filename,
    blob: file,
    type: 'application/pdf',
  });

  const link = document.createElement('a');
  link.href = url || '';
  link.setAttribute('download', `${filename}.pdf`);
  link.click();
}
